import { createApiActions } from '../../../utils/api-state';
import { AutoPayRequest, AutoPayResponse } from '../models/accounts-notifications.model';

export const getAutoPayActions = createApiActions<AutoPayRequest, AutoPayResponse[]>('[Auto Pay] Get Auto Pay Info');
